PJQ.views.invoices.BaseDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No Results Available"
        },
        isHideSearch: true,
        dom: '<"top"p<"clear">>rt<"bottom"p<"clear">>',
        phoneWidth: '125px'
    },
    events: {
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-copy-fax': 'copyPhone',
        'click .btn-copy-cell': 'copyPhone',
        'click .btn-copy-email': 'copyEmail'
    },
    beforeDataTableRender: function () {
        let self = this;
        this.options.rowCallback = function (row, data) {
        };

        this.options.childDataTables = [];

        this.options.contextMenuOptions = {
            actions: this.getContextMenuItems(),
            isHideNoActions: true
        };

        this.options.onRowDoubleClick = _.bind(function (row) {
            if (row.data()) {
                this.editRow(row.data());
            }
        }, this);

        if (this.options.settings) {
            // enable paging for grids that have a setting for it / are not subgrids
            if (this.options.settings.rowsPerPage !== 0 && this.options.view.indexOf('-') === -1)
                this.options.pageLength = this.options.settings.rowsPerPage;
            else
                this.options.pageLength = 2147483646;

            if (this.options.settings.orderBy !== 'sortOrder') {
                if (_.size(this.options.settings.columns) === 0) {
                    this.options.settings.orderBy = this.options.settings.columnsDefault[0];
                }
                else if (this.options.settings.columns.indexOf(this.options.settings.orderBy) === -1) {
                    this.options.settings.orderBy = this.options.settings.columns[0];
                }
            }
            _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
                if (column.columnData === this.options.settings.orderBy) {
                    this.options.order = [[index, this.options.settings.orderAscending ? 'asc' : 'desc']];
                }
            }, this));

            let fixedColumnsLeft = 0;
            this.options.colReorder = {
                fixedColumnsLeft: fixedColumnsLeft,
                realtime: false
            };
        }

        this.options.createdRow = _.bind(this.createdRow, this);

        if (typeof this.options.beforeDataTableRender === 'function') {
            this.options.beforeDataTableRender();
        }
    },
    afterDataTableRender: function () {
        this.$el.on('order.dt', _.bind(function (e, settings, details) {
            if (this.$dataTable[0].id !== settings.oInstance[0].id)
                return;

            if (!this.options.settings)
                return;

            let oldOrder = 0, columns = this.getColumns(false);
            _.each(columns, _.bind(function (column, index) {
                if (column.columnData === this.options.settings.orderBy)
                    oldOrder = index;
            }, this));

            if (oldOrder !== details[details.length - 1].src || this.options.settings.orderAscending !== (details[details.length - 1].dir === 'asc')) {
                this.options.settings.orderBy = columns[details[details.length - 1].src].columnData;
                this.options.settings.orderAscending = details[details.length - 1].dir === 'asc';
                this.options.invoicesView.userSettings.save();
            }
        }, this));

        this.$el.on('column-reorder.dt', _.bind(function (e, settings, details) {
            if (this.$dataTable[0].id !== settings.oInstance[0].id)
                return;

            if (details.drop) {
                let columns = this.getColumns(false);
                _.each(details.mapping, function (newSort, key) {
                    columns[key].sort = newSort;
                });
                this.options.settings.columns = _.map(_.sortBy(_.filter(columns, _.bind(function (column) {
                    return (column.sort > this.options.colReorder.fixedColumnsLeft - 2);
                }, this)), function (column) {
                    return column.sort;
                }), function (column) {
                    return column.columnData;
                });
                this.options.invoicesView.userSettings.save();
            }
        }, this));

        this.$el.on('draw.dt', _.bind(function () {
            this.afterDataTableRenderChild();
        }, this));

        if (typeof this.options.afterDataTableRender === 'function') {
            this.options.afterDataTableRender(this.dataTable);
        }

        this.afterDataTableRenderChild();
    },
    afterDataTableRenderChild: function () {
    },
    getRowChildTable: function (childOpts) {
    },
    getRowChildData: function (row) {
    },
    setRowStyle: function (row, status, isBlacklisted) {
    },
    getContextMenuItems: function () {
    },
    editRow: function (model) {
        let invoice = new PJQ.models.invoices.Invoice();
        invoice.set('invoiceId', model.get('invoiceId'));
        invoice.fetch({
            success: _.bind(function() {
                new PJQ.views.invoices.InvoiceEditModal({
                    model: invoice,
                    invoicesView: this.options.invoicesView,
                    onSave: _.bind(function() {
                        this.options.invoicesView.renderView();
                    }, this),
                    onDelete: _.bind(function() {
                        this.options.invoicesView.renderView();
                    }, this)
                });
            }, this)
        });
    },
    statusChanged: function (statuses) {
    },
    childRowToggle: function (sender) {
        let $target = $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        }
        else {
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');
            let childClass = 'subgrid-' + id.toString(),
                $childTable = $('<div data-id="' + id + '" />', {
                    class: childClass + ' p-2'
                });
            row.child($childTable).show();

            let childData = this.getRowChildData(row);
            if (childData != null) {
                let loader = new PJQ.Loader(this.$el.parent());
                childData.fetch({
                    type: 'POST',
                    data: {
                    },
                    success: _.bind(function () {
                        loader.remove();
                        let childTable = this.getRowChildTable({
                            el: $childTable,
                            data: childData.models,
                            parentId: id,
                            invoicesView: this.options.invoicesView
                        });
                        this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                            return childDt.options.parentId !== id;
                        }, this));
                        this.options.childDataTables.push(childTable);
                        tr.addClass('shown');
                    }, this)
                });
            }
        }
    },
    getColumns: function () {
    },
    cleanup: function () {
        this.undelegateEvents();
        $(this.el).empty();
    },
    getIsRootView: function () {
        return (this.options.view.indexOf('-') === -1);
    },
    createdRow: function (row, data, dataIndex) {
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    copyEmail: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('email'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Email copied to clipboard.'
        });
    }
});

PJQ.views.invoices.InvoiceDataTable = PJQ.views.invoices.BaseDataTable.extend({
    events: {
        'click i.contact-toggle-row': 'childRowToggle',
        'click .btn-view-invoice': 'viewInvoice',
        'click .btn-delete-invoice': 'deleteInvoice',
        'click .btn-copy-phone': function (e) {
            this.copyPhone(e);
        },
        'click .btn-copy-email': function (e) {
            this.copyEmail(e);
        }
    },
    getContextMenuItems: function (a) {
        return [
            {
                name: 'View Invoice',
                iconClass: 'fal fa-file-invoice-dollar',
                onClick: _.bind(function (row) {
                    this.editRow(row.data());
                }, this)
            },
            {
                name: 'Export PDF',
                iconClass: 'fal fa-file-pdf',
                onClick: _.bind(function (row) {
                    this.options.invoicesView.exportInvoice(row.data().get('invoiceId'));
                }, this)
            },
            {
                name: 'Delete Invoice',
                iconClass: 'fal fa-trash',
                isDanger: true,
                onClick: _.bind(function (row) {
                    this.options.invoicesView.deleteInvoice(row.data());
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('invoices.isAdmin') && (row.data().get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.DRAFT || row.data().get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.PAYMENT_REQUESTED);
                }, this)
            }
        ]
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['createdOn', 'createdBy', 'invoiceDate', 'invoiceNumber', 'invoiceStatus', 'total', 'requestedOn','paidOn','voidedOn','refundedOn', 'payor.companyName', 'payor.contactName', 'payor.address1', 'payor.address2', 'payor.city', 'payor.state', 'payor.zip', 'payor.country', 'payor.phone', 'payor.fax', 'payor.email'];

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;
        }
        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {

                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'invoiceNumber':
                    columns.push({
                        "columnData": "invoiceNumber",
                        "data": "attributes.invoiceNumber",
                        "width": '100px',
                        "title": "Invoice #",
                    });
                    break;
                case 'invoiceDate':
                    columns.push({
                        "columnData": "invoiceDate",
                        "data": "attributes.invoiceDate",
                        "title": 'Invoice Date',
                        "width": '100px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('invoiceDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                        }, this)
                    });
                    break;
                case 'total':
                    columns.push({
                        "columnData": "total",
                        "data": "attributes.total",
                        "title": 'Total',
                        "width": '85px',
                        "className": "text-align-right",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('total'));
                        }, this)
                    });
                    break;
                case 'invoiceStatus':
                    columns.push({
                        "columnData": "invoiceStatus",
                        "data": "attributes.invoiceStatus",
                        "title": 'Status',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.invoices.invoiceStatusNames[row.get('invoiceStatusId')];
                        }, this)
                    });
                    break;
                case 'createdBy':
                    columns.push({
                        "columnData": "createdBy",
                        "data": "attributes.createdByDisplay",
                        "title": "Created by",
                    });
                    break;
                case 'requestedOn':
                    columns.push({
                        "columnData": "requestedOn",
                        "data": "attributes.requestedOn",
                        "title": 'Requested',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return row.get('requestedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('requestedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) : '';
                        }, this)
                    });
                    break;
                case 'paidOn':
                    columns.push({
                        "columnData": "paidOn",
                        "data": "attributes.paidOn",
                        "title": 'Paid Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return row.get('paidOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('paidOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) : '';
                        }, this)
                    });
                    break;
                case 'voidedOn':
                    columns.push({
                        "columnData": "voidedOn",
                        "data": "attributes.voidedOn",
                        "title": 'Void Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return row.get('voidedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('voidedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) : '';
                        }, this)
                    });
                    break;
                case 'refundedOn':
                    columns.push({
                        "columnData": "refundedOn",
                        "data": "attributes.refundedOn",
                        "title": 'Refund Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return row.get('refundedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('refundedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) : '';
                        }, this)
                    });
                    break;
                case 'payor.companyName':
                    columns.push({
                        "columnData": "payor.companyName",
                        "data": "attributes.payor.companyName",
                        "title": "Company",
                    });
                    break;
                case 'payor.contactName':
                    columns.push({
                        "columnData": "payor.contactName",
                        "data": "attributes.payor.contactName",
                        "title": "Contact",
                    });
                    break;
                case 'payor.address1':
                    columns.push({
                        "columnData": "payor.address1",
                        "data": "attributes.payor.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'payor.address2':
                    columns.push({
                        "columnData": "payor.address2",
                        "data": "attributes.payor.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'payor.city':
                    columns.push({
                        "columnData": "payor.city",
                        "data": "attributes.payor.city",
                        "title": "City"
                    });
                    break;
                case 'payor.state':
                    columns.push({
                        "columnData": "payor.state",
                        "data": "attributes.payor.state",
                        "title": "State",
                    });
                    break;
                case 'payor.zip':
                    columns.push({
                        "columnData": "payor.zip",
                        "data": "attributes.payor.zip",
                        "title": "Postal Code",
                    });
                    break;
                case 'payor.country':
                    columns.push({
                        "columnData": "payor.country",
                        "data": "attributes.payor.country",
                        "title": "Country",
                    });
                    break;
                case 'payor.phone':
                    columns.push({
                        "columnData": "payor.phone",
                        "data": "attributes.payor.phone",
                        "title": "Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('payor').phone ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('payor').phone) : 'N/A');

                            if (row.get('payor').phone !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('payor').phone ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'payor.fax':
                    columns.push({
                        "columnData": "payor.fax",
                        "data": "attributes.payor.fax",
                        "title": "Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('payor').fax ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('payor').fax) : 'N/A');

                            if (row.get('payor').fax !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('payor').fax ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'payor.email':
                    columns.push({
                        "columnData": "payor.email",
                        "data": "attributes.payor.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('payor').email ? ('<a title="' + row.get('payor').email + '" style="color: inherit;" href="mailto:' + row.get('payor').email + '">' + row.get('payor').email + '</a>') : '');

                            if (row.get('payor').email !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('payor').email + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('payor').email ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {

                    let html = '<div class="show-on-row-hover">';
                    html += '<button type="button" class="btn btn-info btn-view-invoice ml-1" title="View Invoice"><i class="fal fa-arrow-alt-from-left"></i></button>';

                    if (PJQ.app.session.hasPermission('invoices.isAdmin') && (row.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.DRAFT || row.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.PAYMENT_REQUESTED))
                        html += '<button type="button" class="btn btn-danger btn-delete-invoice ml-1" title="Delete Invoice"><i class="fal fa-trash"></i></button>';

                    html += '</div>';

                    return html;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "100px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    viewInvoice: function(e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.editRow(row.data());
    },
    deleteInvoice: function(e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.options.invoicesView.deleteInvoice(row.data());
    }
});

PJQ.views.invoices.TransactionDataTable = PJQ.views.invoices.BaseDataTable.extend({
    events: {
        'click i.contact-toggle-row': 'childRowToggle',
        'click .btn-copy-phone': function (e) {
            this.copyPhone(e);
        },
        'click .btn-copy-email': function (e) {
            this.copyEmail(e);
        }
    },
    getContextMenuItems: function (a) {
        return [
            {
                name: 'View Invoice',
                iconClass: 'fal fa-file-invoice-dollar',
                onClick: _.bind(function (row) {
                    this.editRow(row.data());
                }, this)
            }
        ]
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['createdOn', 'invoiceDate', 'invoiceNumber', 'paymentType', 'transactionType', 'last4', 'paymentReference', 'amount', 'payor.companyName', 'payor.contactName', 'payor.address1', 'payor.address2', 'payor.city', 'payor.state', 'payor.zip', 'payor.country', 'payor.phone', 'payor.fax', 'payor.email'];

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;
        }
        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'invoiceNumber':
                    columns.push({
                        "columnData": "invoiceNumber",
                        "data": "attributes.invoiceNumber",
                        "width": '100px',
                        "title": "Invoice #",
                    });
                    break;
                case 'invoiceDate':
                    columns.push({
                        "columnData": "invoiceDate",
                        "data": "attributes.invoiceDate",
                        "title": 'Invoice Date',
                        "width": '100px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('invoiceDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "title": 'Amount',
                        "width": '85px',
                        "className": "text-align-right",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'last4':
                    columns.push({
                        "columnData": "last4",
                        "data": "attributes.last4",
                        "width": '60px',
                        "title": "Last 4",
                    });
                    break;
                case 'paymentType':
                    columns.push({
                        "columnData": "paymentType",
                        "data": "attributes.paymentType",
                        "width": '100px',
                        "title": 'Method',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.invoices.paymentTypeNames[row.get('paymentTypeId')];
                        }, this)
                    });
                    break;
                case 'transactionType':
                    columns.push({
                        "columnData": "transactionType",
                        "data": "attributes.transactionType",
                        "title": 'Type',
                        "width": '100px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.invoices.transactionTypeNames[row.get('transactionTypeId')];
                        }, this)
                    });
                    break;
                case 'paymentReference':
                    columns.push({
                        "columnData": "paymentReference",
                        "data": "attributes.paymentReference",
                        "title": "Payment Ref.",
                    });
                    break;
                case 'payor.companyName':
                    columns.push({
                        "columnData": "payor.companyName",
                        "data": "attributes.payor.companyName",
                        "title": "Company",
                    });
                    break;
                case 'payor.contactName':
                    columns.push({
                        "columnData": "payor.contactName",
                        "data": "attributes.payor.contactName",
                        "title": "Contact",
                    });
                    break;
                case 'payor.address1':
                    columns.push({
                        "columnData": "payor.address1",
                        "data": "attributes.payor.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'payor.address2':
                    columns.push({
                        "columnData": "payor.address2",
                        "data": "attributes.payor.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'payor.city':
                    columns.push({
                        "columnData": "payor.city",
                        "data": "attributes.payor.city",
                        "title": "City"
                    });
                    break;
                case 'payor.state':
                    columns.push({
                        "columnData": "payor.state",
                        "data": "attributes.payor.state",
                        "title": "State",
                    });
                    break;
                case 'payor.zip':
                    columns.push({
                        "columnData": "payor.zip",
                        "data": "attributes.payor.zip",
                        "title": "Postal Code",
                    });
                    break;
                case 'payor.country':
                    columns.push({
                        "columnData": "payor.country",
                        "data": "attributes.payor.country",
                        "title": "Country",
                    });
                    break;
                case 'payor.phone':
                    columns.push({
                        "columnData": "payor.phone",
                        "data": "attributes.payor.phone",
                        "title": "Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('payor.phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('payor.phone')) : 'N/A');

                            if (row.get('payor.phone') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('payor.phone') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'payor.fax':
                    columns.push({
                        "columnData": "payor.fax",
                        "data": "attributes.payor.fax",
                        "title": "Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('payor.fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('payor.fax')) : 'N/A');

                            if (row.get('payor.fax') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('payor.fax') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'payor.email':
                    columns.push({
                        "columnData": "payor.email",
                        "data": "attributes.payor.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('payor.email') ? ('<a title="' + row.get('payor.email') + '" style="color: inherit;" href="mailto:' + row.get('payor.email') + '">' + row.get('payor.email') + '</a>') : '');

                            if (row.get('payor.email') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('payor.email') + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
            }

        }, this));

        return columns;
    }
});
